const layers = {
  base: 0,
  stage: 100,
  pane: 200,
  drawer: 300,
  content: 400,
  flyout: 500,
  dock: 600,
  workbench: 700,
  globalOverlay: 800,
  dialog: 900,
  overlay: 1000,
  alert: 1200,
  // Above alert so a tooltip triggered from inside a toast isn't hidden by neighboring toasts
  tooltip: 1300,
} as const;

export const stateZIndexes = {
  base: 0,
  boundary: layers.base,
  initial: layers.base + 1,
  hover: layers.base + 2,
  selected: layers.base + 3,
  focus: layers.base + 4,
  fixture: layers.base + 5,
};

export const zIndexes = {
  // Base
  base: layers.base,

  // Stage
  stage: layers.stage,

  // Panes
  pane: layers.pane,
  paneDrawer: layers.pane + 1,
  paneStuck: layers.pane + 2,
  paneSticky: layers.pane + 3,

  // Drawer
  drawer: layers.drawer,
  drawerContent: layers.drawer + 1,
  drawerWash: layers.drawer - 1,
  drawerSticky: layers.drawer + 2,

  // Content
  content: layers.content,
  contentLoading: layers.content + 1,

  // Flyouts
  flyout: layers.flyout,

  // Dock
  dock: layers.dock,
  dockArea: layers.dock + 1,
  dockToolbar: layers.dock + 2,

  // Global alert banner
  banner: layers.flyout - 20,

  // Minimizer
  minimizer: layers.flyout + 1,

  // Workbench
  workbench: layers.workbench,

  // Global overlays (rendered below dialogs)
  globalOverlay: layers.globalOverlay,

  // Dialogs
  dialog: layers.dialog,
  dialogContent: layers.dialog + 1,
  dialogWash: layers.dialog - 1,

  // Overlays
  overlay: layers.overlay,
  overlayContent: layers.overlay + 1,
  overlayWash: layers.overlay - 1,

  // Alerts
  alert: layers.alert,

  // Tooltips
  tooltip: layers.tooltip,
};
